import {useAccessToken} from './useAccessToken';
import {useMeQuery} from './useMeQuery';

export function useShouldPromoteMobileApp() {
  const isLoggedIn = useAccessToken().isSuccess;
  const hasPaid = !!useMeQuery().data?.has_paid;

  return isLoggedIn && hasPaid;
}
